import config from '../../config/config';

const getValidVideoAngle = (angle: number): number => {
  const validAngles = config.options.roofAngles.map((a) => a.value);
  if (validAngles.includes(angle)) return angle;

  const closest = validAngles.reduce((a, b) => {
    const aDiff = Math.abs(a - angle);
    const bDiff = Math.abs(b - angle);
    if (aDiff === bDiff) {
      // Choose largest vs smallest (> vs <)
      return a > b ? a : b;
    }
    return bDiff < aDiff ? b : a;
  });
  return closest;
};

export default getValidVideoAngle;
